import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import AddRaiseTicket from "./AddRaiseTicket";
// import { ServiceComponent } from "./InsideComponent/ServiceComponent";
// import { TechnicalComponent } from "./InsideComponent/TechnicalComponent";
// import { PaymentsComponent } from "./InsideComponent/PaymentsComponent";
// import { BookinCancelComponent } from "./InsideComponent/BookinCancelComponent";
// import { OrdersComponent } from "./InsideComponent/OrdersComponent";
import { OthersComponent } from "./InsideComponent/OthersComponent";
import Media from "react-media";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { vendor_get_all_help_faq } from "../../../store/actions/SuperAdminActions/superAdminFAQAction";
import { getAllCateogryForIcons } from "../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import isEmpty from "../../../store/validation/is-Empty";

export class HelpPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "",
      allVendorHelpFaq: [],
      groupById: [],
      finalTabData: [],
    };
  }

  componentDidMount() {
    this.props.getAllCateogryForIcons(this.onSuccessCategory);
    this.props.vendor_get_all_help_faq();
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.vendorHelpFaq) !== nextState.allVendorHelpFaq) {
      return {
        allVendorHelpFaq: !isEmpty(nextProps.vendorHelpFaq)
          ? nextProps.vendorHelpFaq
          : [],
      };
    }
  }

  onSuccessCategory = (data) => {
    for (let i = 0; i < data.length; i++) {
      this.setState({
        groupById: data[i].category_name,
      });
    }
  };

  onPageChange = (operation, groupby) => (e) => {
    let finalTabData = groupby[operation.category_id._id];
    this.setState({
      selectedTab: operation.category_id._id,
      finalTabData: finalTabData,
    });
  };

  groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
      const key = obj.category_id[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  };

  filteredArr = (objectArray) => {
    return objectArray.reduce((acc, current) => {
      const x = acc.find(
        (item) => item.category_id._id === current.category_id._id
      );
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
  };

  render() {
    const { selectedTab, allVendorHelpFaq, finalTabData } = this.state;
    const groupedPeople = this.groupBy(this.state.allVendorHelpFaq, "_id");
    const filteredArr = this.filteredArr(allVendorHelpFaq);
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            <Col
              id="loginsignup-leftside-scroll"
              className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside"
            >
              <div className="col-12 px-lg-0 display-top-header-mobile">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  backButtonClicked="/"
                  notDisplaProgressBar={true}
                />
              </div>
              <Col className="login-help-page-margin">
                <Row className="d-flex align-items-center ">
                  <Col md={4}>
                    <div className="f24_700_HelveticaNeue">Help</div>
                  </Col>

                  <Media query="(min-width: 992px)">
                    <Col md={8}>
                      <div className="d-flex align-items-center justify-content-end">
                        <span className="f16-500">Need Help? </span>
                        <AddRaiseTicket />
                      </div>
                    </Col>
                  </Media>
                </Row>
                <div>
                  <div className="d-flex align-items-center">
                    <h4 className="help-text-heading4">Stuck Somewhere?</h4>
                    <p className="help-text-heading4 help-text-heading4-orange">
                      We can help you.
                    </p>
                  </div>
                  <p className="help-text-paragraph4">
                    Having trouble? We’re here to help. Our goal is to provide
                    you best experience using Amealio, below is list of FAQs’ to
                    help you. Whether you have a question about our products,
                    features, opportunity, partnership or feedback. our team is
                    ready to help you with your question. Get in touch with us.
                  </p>
                </div>
                <div>
                  <h4 className="help-text-heading4">
                    Frequently Asked Questions
                  </h4>
                  <p className="help-text-paragraph4">
                    Here are questions that people ask very frequently. If you
                    have any of these questions it could help you , if you do
                    not find anything you can drop us a line and we’ll be glad
                    to help you.
                  </p>
                </div>
                <div className="nav-scroller helpTab">
                  <nav className="nav d-flex justify-content-between">
                    <div className="help-text-section-tab mt-3">
                      {filteredArr &&
                        filteredArr.map((helpFaq, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div
                                className={
                                  selectedTab === helpFaq.category_id._id
                                    ? "help-text-section-tab-button-active"
                                    : "help-text-section-tab-button"
                                }
                                onClick={this.onPageChange(
                                  helpFaq,
                                  groupedPeople
                                )}
                              >
                                {helpFaq &&
                                  helpFaq.category_id &&
                                  helpFaq.category_id.category_name}
                              </div>
                            </React.Fragment>
                          );
                        })}
                    </div>
                  </nav>
                </div>

                <hr className="mt-0" />
                <div className="">
                  {finalTabData &&
                    finalTabData.map((helpFaq, index) => {
                      return (
                        <React.Fragment key={index}>
                          <OthersComponent
                            question={helpFaq.question}
                            answer={helpFaq.answer}
                          />
                        </React.Fragment>
                      );
                    })}
                </div>
                <Media query="(min-width: 992px)">
                  <div className="d-flex align-items-center justify-content-start">
                    <span className="f16-500">Need Help? </span>
                    <AddRaiseTicket />
                  </div>
                </Media>
                <Media query="(max-width: 992px)">
                  <AddRaiseTicket extraClass="btn w-100 btn-danger btn-md text-white mb-3" />
                </Media>
              </Col>
            </Col>

            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                    .default
                }
              />
            </Col>
          </Row>
        </Container>
        {/* <ParticlesBg color="#636466" num={175} type="cobweb" bg={true} /> */}
      </React.Fragment>
    );
  }
}

HelpPageComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  vendor_get_all_help_faq: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  vendorHelpFaq: state.superAdminHelpFaq.get_vendor_help_faq,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_get_all_help_faq,
  getAllCateogryForIcons,
})(withRouter(HelpPageComponent));
